type SectionHeadingProps = {
  kicker?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
};

export default function SectionHeading({
  kicker,
  title,
  description,
  align = 'left',
  tone = 'dark',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const titleColor = tone === 'light' ? 'text-background-50' : 'text-foreground-950';
  const descColor = tone === 'light' ? 'text-background-200' : 'text-foreground-600';
  const kickerColor = tone === 'light' ? 'text-accent-300' : 'text-primary-600';

  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-2xl' : 'text-left max-w-3xl'}`}>
      {kicker ? (
        <p className={`font-mono text-xs tracking-[0.3em] uppercase mb-3 ${kickerColor}`}>
          {kicker}
        </p>
      ) : null}
      <h2 className={`font-heading text-2xl md:text-4xl font-bold leading-tight ${titleColor}`}>
        {title}
      </h2>
      {description ? (
        <p className={`mt-4 text-sm md:text-base leading-relaxed ${descColor}`}>{description}</p>
      ) : null}
    </div>
  );
}